(function(urlLocale) {
    // Loads in a user's profile into the navbar via ajax
    if ($(document.body).hasClass('is-logged-in')) {
        $('[data-js=login-button]').load('/' + urlLocale + '/user/profile');

        // Loads in a cms edit button via ajax
        $('[data-js=cms-edit]').load(
            '/' +
            urlLocale +
            '/user/cms?blogId=' +
            $('[data-js=cms-edit]').data('blog')
        );
    }
})(window.blizzard.urlLocale);
